// extracted by mini-css-extract-plugin
module.exports = {"container":"Insurance_container__Fc2br","create":"Insurance_create__2c2rA"};